<template>
  <div v-if="detail != ''" class="container">
    <!-- 详情 -->
    <section>
      <h3>{{ detail.device_name }}</h3>
      <ul>
        <li>
          <label>项目名称：</label>
          <p>{{ detail.project_name }}</p>
        </li>
        <li>
          <label>地址：</label>
          <p>{{ detail.address }}</p>
        </li>
        <li>
          <label>设备厂商：</label>
          <p v-show="detail.firm_id == 1">易触</p>
          <p v-show="detail.firm_id == 2">华屹1</p>
          <p v-show="detail.firm_id == 3">华屹2</p>
          <p v-show="detail.firm_id == 4">卡游</p>
        </li>
        <li>
          <label>设备编号：</label>
          <p>{{ detail.device_unique_id }}</p>
        </li>
        <li>
          <label>设备类型：</label>
          <p v-show="detail.version == 1">一代机</p>
          <p v-show="detail.version == 2">二代机</p>
          <p v-show="detail.version == 3">三代机</p>
        </li>
        <li>
          <label>销售情况：</label>
          <p v-show="detail.sale_type == 1">非热销</p>
          <p v-show="detail.sale_type == 2">热销</p>
        </li>
        <li>
          <label>撤柜退回：</label>
          <p v-show="detail.is_return_type == 1">公司</p>
          <p v-show="detail.is_return_type == 2">甲方</p>
          <p v-show="detail.is_return_type == 0">未撤柜</p>
        </li>
        <li>
          <label>进场入库：</label>
          <p v-show="detail.is_entry == 1">是</p>
          <p v-show="detail.is_entry == 0">否</p>
        </li>
        <li>
          <label>是否缺物料：</label>
          <p v-show="detail.is_need_material == 1">是</p>
          <p v-show="detail.is_need_material == 0">否</p>
        </li>
        <li>
          <label>是否缺货：</label>
          <p v-show="detail.is_need_add == 1">是</p>
          <p v-show="detail.is_need_add == 0">否</p>
        </li>
        <li v-show="detail.is_need_add == 1">
          <label>缺货时间：</label>
          <p>{{ detail.need_add_time }}</p>
        </li>
        <li v-show="detail.is_need_add == 1">
          <label>缺货原因：</label>
          <p>{{ detail.reason }}</p>
        </li>
        <li>
          <label>创建时间：</label>
          <p>{{ detail.create_time }}</p>
        </li>
        <li>
          <label>修改时间：</label>
          <p>{{ detail.update_time }}</p>
        </li>
        <li v-show="detail.is_setprice == 2">
          <label>甲方补货结算价：</label>
          <p>{{ detail.price }}</p>
        </li>
        <li v-show="detail.is_setprice == 2">
          <label>甲方上新结算价：</label>
          <p>{{ detail.new_price }}</p>
        </li>
        <li v-show="detail.is_setprice == 2">
          <label>甲方美陈结算价：</label>
          <p>{{ detail.pretty_price }}</p>
        </li>
      </ul>
      <div class="operation" v-show="detail.is_return_type == 0">
        <a-button @click="returnMachine" type="danger" ghost>
          撤柜退回
        </a-button>
      </div>
    </section>
    <!-- 详情 end -->
    <!-- 缺货信息表 -->
    <section class="kyFormList">
      <div class="stockoutTitle">
        <h3>缺货信息表</h3>
        <a-button class="resetStyle">
          <a-icon type="vertical-align-bottom" />下载
        </a-button>
      </div>
      <table>
        <thead>
          <th>商品名称</th>
          <th>商品图</th>
          <th>现有库存</th>
          <th>缺货数量</th>
          <th>缺物料数量</th>
        </thead>
        <tbody>
          <tr v-for="(element, idx) in stockoutGoodsList" :key="idx + 't'">
            <td>{{ element.brand_name }}</td>
            <td>
              <img class="imgStyle" :src="element.imageUrl.url" />
            </td>
            <td>{{ element.real_inventory }}</td>
            <td>{{ element.supplement_no }}</td>
            <td>{{ element.need_add }}</td>
          </tr>
          <tr v-show="stockoutGoodsList == ''">
            <td></td>
            <td></td>
            <td>暂无数据</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </section>
    <!-- 缺货信息表 end -->
    <!-- 撤柜退回 -->
    <aside class="dialogsBox" v-show="showIsReturnMachine">
      <div>
        <h3>撤柜退回</h3>
        <a-icon
          class="close"
          type="close-circle"
          @click="showIsReturnMachine = false"
        />
        <ul>
          <li>
            <label><i>*</i>请选择网点设备物料退回渠道：</label>
            <br />
            <a-radio-group v-model="is_return_type">
              <a-radio :value="1">
                公司
              </a-radio>
              <a-radio :value="2">
                甲方
              </a-radio>
            </a-radio-group>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitReturnMachine">
            确认
          </a-button>
        </div>
      </div>
    </aside>
    <!-- 撤柜退回 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      images: [],
      showIsReturnMachine: false,
      is_return_type: "",
      stockoutGoodsList: []
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      this.getStockoutGoodsList();
      // console.log(this.detail);
    },
    getStockoutGoodsList() {
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/needAddList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        device_id: this.detail.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res);
          this.stockoutGoodsList = res.data.data;
        }
      });
    },
    returnMachine() {
      this.showIsReturnMachine = true;
    },
    submitReturnMachine() {
      if (this.is_return_type != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Project/devicematerialreturn";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          device_id: this.detail.id,
          is_return_type: this.is_return_type
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("该设备已撤柜");
            this.showIsReturnMachine = false;
          } else {
            this.showIsReturnMachine = false;
            this.$info({
              title: "撤柜失败",
              content: res.data.message,
              onOk() {}
            });
          }
        });
      } else {
        this.$message.error("请选择退回渠道！");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 3.2%;
  > section {
    h3 {
      font-size: 20px;
      margin: 20px 0;
    }
    ul {
      li {
        display: inline-block;
        width: 33.3%;
        vertical-align: top;
        margin-bottom: 20px;
        label,
        p {
          display: inline-block;
          vertical-align: top;
        }
        p {
          max-width: 70%;
          word-wrap: break-word;
        }
        .imgStyle {
          display: inline-block;
          vertical-align: top;
        }
        img {
          width: 100px;
          height: 100px;
          border: 1px solid #ededed;
          object-fit: cover;
        }
      }
    }
    .operation {
      button {
        margin-right: 20px;
      }
    }
  }
  .kyFormList {
    width: 50%;
  }
  .stockoutTitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
    h3 {
      font-size: 14px;
    }
  }
  table {
    width: 100%;
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
}
</style>
